const initIsotopeJs = (selector) => {
  var $grid = $(".grid-brands").isotope();
  $(".filter-button-group").on("click", "button", function() {
    var filterValue = $(this).attr("data-filter");
    $(".filter-button-group button").removeClass("active");
    $(this).addClass("active");
    $grid.isotope({ filter: filterValue });
    if ($(".grid-brands").height() == 0) {
      $(".no-result").show();
    } else {
      $(".no-result").hide();
    }
  });
};
export default initIsotopeJs;
